import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus, getData } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";
import { getEncoded } from "@/common/helpers/helpers";
import navs from "@/from-theme/routes/constants/nav";
import { useNavigate } from "react-router";

export default function useOnActions() {
  const [isAlertDialog, setIsAlertDialog] = useState(false);

  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);
  const [currentRowId, setCurrentRowId] = useState(null);
  
  const [selectedRejectedCustomer, setSelectedRejectedCustomer] = useState(null);
  const [isRejectedModalOpen, setIsRejectedModalOpen] = useState(false);

  const [selectedRejectedScheme, setSelectedRejectedScheme] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailsRefreshTrigger, setDetailsRefreshTrigger] = useState(0);

  const onRefreshDetails = useCallback(() => {
    setDetailsRefreshTrigger(prev => prev + 1);
  }, []);

 

  const deleteCompetitorMasterStatus = getStatus(state, apiKeys.deleteCompetitorMaster, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deleteCompetitorMaster(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deleteCompetitorMaster,
      successMsg: formatMessage({ id: "competitor-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-competitor-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);

  const onRowEdit = useCallback((id) => {
    // navigate(navs.editIfdCompetitorMaster(getEncoded(id)))
    navigate(navs.editSchemesListMaster(getEncoded(id)))
  }, [navigate]);

  const onViewDetailed = useCallback((scheme) => {
    setSelectedRejectedScheme(scheme);
    setIsDetailModalOpen(true);
  }, []);

  const onRowEditCustomer = useCallback((customer) => {
    // If we pass the whole customer object directly, use it
    if (typeof customer === 'object') {
      setSelectedRejectedCustomer(customer);
      setIsRejectedModalOpen(true);
      return;
    }

    // Otherwise find by ID in the detailed list
    const dataList = getData(state, apiKeys.schemeRejectedCustomersDetail, []);
    const found = dataList.find(c => String(c.id) === String(customer));
    if (found) {
      setSelectedRejectedCustomer(found);
      setIsRejectedModalOpen(true);
    } else {
      console.error("Customer not found for id:", customer);
    }
  }, [state]);

  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.deleteCompetitorMaster }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowEdit,
    onRowDelete,
    deleteCompetitorMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
    onRowEditCustomer,
    selectedRejectedCustomer,
    isRejectedModalOpen,
    setIsRejectedModalOpen,
    onViewDetailed,
    selectedRejectedScheme,
    isDetailModalOpen,
    setIsDetailModalOpen,
    detailsRefreshTrigger,
    onRefreshDetails
  }), [
    onRowEdit,
    onRowDelete,
    deleteCompetitorMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
    onRowEditCustomer,
    selectedRejectedCustomer,
    isRejectedModalOpen,
    onViewDetailed,
    selectedRejectedScheme,
    isDetailModalOpen,
    detailsRefreshTrigger,
    onRefreshDetails
  ])
}
